import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import ChequeList from "../../components/Cheque/List/ChequeList";
import { withRouter } from "react-router";

export const typeChequeName = (type) => {
  switch (type) {
    case "bounced":
      return "برگشت خورده";
    case "cashed":
      return "پاس شده";
    case "future":
      return "پیش رو";
    case "returned-settlement":
      return "عودتی - تسویه";
    case "returned-unresolved":
      return "عودتی - بلاتکلیف";
    default:
      return "";
  }
};

const ChequeListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست چک ها",
            to: "/cheque/list/all",
          },
          {
            title: "لیست چک ها " + typeChequeName(props.match.params.type),
            to: props.history.location.pathname,
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <ChequeList isAdvanced={true} type={props.match.params.type} />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default withRouter(ChequeListPage);
